import { FC, useMemo, useState } from 'react';

import { BsChevronRight } from 'react-icons/bs';
import { cn } from 'utils/helpers';

interface PROPS {
  className?: string | string[];
  headClassName?: string | string[];
  icon?: () => JSX.Element;
  label: string | JSX.Element;
  arrowLeft?: boolean;
  content?: JSX.Element;
  defaultOpen?: boolean;
  action?: React.ReactNode;
  subElement?: ({ open }: { open: boolean }) => JSX.Element;
  onMouseEnter?: () => void;
  onMouseLeave?: () => void;
  arrowClassname?: string;
  setManualOpen?: () => void;
  manualOpen?: boolean;
  isCadence?: boolean;
  isAbsoluteButton?: boolean;
}

const Accordion: FC<PROPS> = ({
  className,
  headClassName,
  icon,
  label,
  arrowLeft,
  content,
  defaultOpen = false,
  action,
  subElement,
  onMouseEnter,
  onMouseLeave,
  arrowClassname,
  manualOpen,
  setManualOpen,
  isCadence,
  isAbsoluteButton = true,
  ...rest
}) => {
  const [open, setOpen] = useState(defaultOpen);

  const openController = useMemo(
    () => (typeof manualOpen !== 'undefined' ? manualOpen : open),
    [manualOpen, open],
  );

  return (
    <div
      className={cn(
        'relative',
        isCadence && 'p-6 rounded-lg bg-[#F1F4F8]',
        className,
      )}
      {...rest}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <div className="flex items-center justify-between">
        <div className={cn('block', 'w-full', headClassName)}>
          <div
            className={cn(
              arrowLeft && 'justify-start gap-2 items-start',
              'flex w-full gap-2.5',
            )}
          >
            <div className={cn(arrowLeft && 'order-2', 'w-full')}>
              {typeof label === 'string' ? (
                <div className="label flex w-full justify-between">
                  <div className="flex items-center gap-2">
                    {icon?.()}
                    <h4 className="text-left text-[14px] font-semibold leading-[20px]">
                      {label}
                    </h4>
                  </div>
                  {!!action && action}
                </div>
              ) : (
                label
              )}
              {subElement && subElement({ open: openController })}
            </div>
            <button
              type="button"
              onClick={() => {
                setManualOpen?.();
                setOpen(!open);
              }}
              className={cn(
                'transition duration-200 text-primary-base',
                openController && 'rotate-90',
                arrowLeft && 'order-1 mt-1',
                typeof label !== 'string' &&
                  isAbsoluteButton &&
                  'absolute top-5 right-4',
                arrowClassname,
              )}
            >
              <BsChevronRight />
            </button>
          </div>
        </div>
      </div>
      <div
        className={cn(
          'transition-all duration-200',
          openController ? 'max-h-[2000px]' : 'max-h-[0px] overflow-y-hidden',
        )}
      >
        {content}
      </div>
    </div>
  );
};

export default Accordion;
